import type { LocaleLoaders } from '@wegic/i18n-core';
import { I18nLanguage } from '@wegic/i18n-core';

import de from './locales/de.json';
import en from './locales/en.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
import it from './locales/it.json';
import ja from './locales/ja.json';
import nl from './locales/nl.json';
import ptBR from './locales/pt-br.json';
import ptPT from './locales/pt-pt.json';
import tr from './locales/tr.json';
import vi from './locales/vi.json';
import zhCN from './locales/zh-cn.json';
import zhHK from './locales/zh-hk.json';

/**
 * Changelog Modal 包的 i18n 命名空间
 */
export const CHANGELOG_I18N_NAMESPACE = 'changelog-modal';

/**
 * Changelog Modal 包的 i18n 加载器配置
 */
export const changelogI18nLoaders: LocaleLoaders = {
  [I18nLanguage.en]: en,
  [I18nLanguage.ja]: ja,
  [I18nLanguage.de]: de,
  [I18nLanguage.fr]: fr,
  [I18nLanguage.es]: es,
  [I18nLanguage.it]: it,
  [I18nLanguage.nl]: nl,
  [I18nLanguage.tr]: tr,
  [I18nLanguage.zhCN]: zhCN,
  [I18nLanguage.zhHK]: zhHK,
  [I18nLanguage.ptPT]: ptPT,
  [I18nLanguage.ptBR]: ptBR,
  [I18nLanguage.vi]: vi,
};
